// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__czFeR","title":"ClientCherryInfo_title__ycuhO","itemText":"ClientCherryInfo_itemText__18VVB"};